export default {
  getDate () {
    const newDate = new Date()
    newDate.setHours(0, 0, 0, 0)
    return newDate
  },

  dateFromString (date) {
    if (typeof date === 'string') {
      const dateStr = date.split('-')
      return new Date(dateStr[0], dateStr[1] - 1, dateStr[2].split(' ')[0], 0, 0, 0)
    } else {
      return date
    }
  },

  formatDate (date = new Date()) {
    let dateStr = date.getFullYear() + '-'
    const month = date.getMonth() + 1
    dateStr += ((month < 10) ? '0' : '') + month + '-'
    const day = date.getDate()
    dateStr += ((day < 10) ? '0' : '') + day

    return dateStr
  },

  dayBefore (date = new Date(), days = 1) {
    const clonedDate = this.cloneDate(date)
    const day = clonedDate.getDate()
    return new Date(clonedDate.setDate(day - days))
  },

  dayAfter (date = new Date(), days = 1) {
    const clonedDate = this.cloneDate(date)
    const day = clonedDate.getDate()
    return new Date(clonedDate.setDate(day + days))
  },

  cloneDate (date) {
    let clonedDate = null

    if (typeof date === 'string') {
      clonedDate = this.dateFromString(date)
    } else {
      clonedDate = new Date(date.getTime())
    }

    return clonedDate
  }
}
